import React from 'react';
import classNames from 'classnames';

export interface EmptyStateProps {
  message: string;
  icon?: JSX.Element;
  children?: JSX.Element;
  isSmall?: boolean;
  dataTestId?: string;
}
export default function EmptyState({
  message,
  icon,
  children,
  isSmall = false,
  dataTestId,
}: EmptyStateProps) {
  return (
    <div
      className={classNames('empty-state', { 'empty-state--small': isSmall })}
      data-test-id={dataTestId}
    >
      <div className="d-flex flex-column justify-content-center align-items-center col-12 col-md-6">
        {icon && (
          <div
            className={classNames('empty-state__icon', {
              'empty-state__icon--small': isSmall,
            })}
          >
            {icon}
          </div>
        )}
        <p className="empty-state__message">{message}</p>
        <div className="w-auto">{children}</div>
      </div>
    </div>
  );
}
